import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDateTimeToDayAgo'
})
export class ConvertDateTimeToDayAgoPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value)
      return this.timeSince(value);
    return null;
  }
  private timeSince(date): string {
    const _d = (new Date() as any) - Date.parse(date);
    const seconds = Math.floor(_d / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) {
      return Math.floor(interval) + " سال قبل";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " ماه قبل";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " روز قبل";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " ساعت قبل";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " دقیقه قبل";
    }
    return Math.floor(seconds) + " ثانیه قبل";
  }
}
